import pushGTMWithDelay from 'utils/pushGTMWithDelay';
import { pushGTMBookingFormSubmitted, pushGTMBookingLeadCreated } from 'utils/gtm';
import { setLocation, setPersonalData, setUserSelectedCity } from 'components/Booking-new/actions';
import stepTypes from 'components/Booking-new/modules/Steps/types';
import leadService from 'services/LeadService';
import setSessionStorage from '../../../../../utils/setSessionStorage';

const saveLeadDataAndPushGTM = async (
  shouldCreateLead,
  state,
  navigation,
  dispatch,
  formData,
  leadAdditionalData,
  selectedCity,
) => {
  dispatch(setPersonalData(formData));

  const funnelType = state.funnelType;
  const hasTimeStep = state?.allSteps.some(step => step.type === 'ContentfulBookingStepTime');

  // Creating lead only when is enabled from contentful
  if (shouldCreateLead) {
    // Submit lead data
    const res = await leadService.sendLeadData({ formData, additionalData: leadAdditionalData });

    if (res) {
      const { masterId, uuid, sfUuid } = res || {};
      const { email, phoneNumber } = formData;

      // Storing lead details to be used with waitlist in Time component.
      setSessionStorage('leadData', { masterId, uuid });

      // trigger GTM event if "Lead Created"
      pushGTMWithDelay(33, pushGTMBookingLeadCreated, {
        masterId,
        uuid,
        email,
        phoneNumber,
        funnelType,
        sfUuid,
      });
    }
  }

  const eventBody = {
    event: 'gtmEvent',
    eventCategory: 'Booking funnel',
    eventAction: 'booking form submitted',
    eventNonInteraction: 'False',
    funnelType,
  };

  pushGTMWithDelay(33, pushGTMBookingFormSubmitted, eventBody);
  if (shouldCreateLead) {
    const locations = selectedCity?.locations;
    dispatch(setUserSelectedCity(selectedCity));
    // If user select a city with couple of dispensary locations,
    // we take user to the next step of booking-location(BookingStepLocations),
    // and we show dispensary locations based on the city user selected.
    // THIS APPLIED TO LEAD BOOKING PROCESS
    if (locations?.length > 1) {
      navigation.goToNextStep();
      return;
    }

    // If user select a city with only one dispensary,
    // we will skip user from booking-location(BookingStepLocations) and take him directly
    // to select timeslot(BookingStepTime) for the dispensary.
    // This only applied to LEAD BOOKING PROCESS.
    if (locations?.length === 1) {
      const location = locations[0];
      dispatch(setLocation(location));
      // if time and location step then go tot next step
      if (!hasTimeStep) navigation.goToNextStep();
      // Skipping one step by going directly BookingStepTime rather than BookingStepLocation.
      else navigation.goToStepType(stepTypes.time);
      return;
    }
  }

  navigation.goToNextStep();
};

export default saveLeadDataAndPushGTM;
